import { useMemo } from "react";

import { ElementWithIcon } from "@/Common/Components/ElementWithIcon";
import { Icon } from "@/Common/Components/IconControls/IconControls";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { ContactDirectoryHelper } from "@/ContactDirectory/Helpers/ContactDirectoryHelper";
import { FaxDirectorySearchResultItem } from "./FaxDirectorySearchResultItem";

import styles from "./DirectorySearchTitle.module.scss";

interface IDirectorySearchTitleProps {
    searchResultItem: FaxDirectorySearchResultItem;
    isSubItem?: boolean;
    disableEdit?: boolean;
}

export function DirectorySearchTitle(props: IDirectorySearchTitleProps): JSX.Element {
    const { getText } = useTranslation();

    const title = useMemo(() => props.searchResultItem?.getDisplayName(), [props.searchResultItem]);

    if (!props.searchResultItem)
        return null;

    const isApproved = props.searchResultItem.entity?.isApproved;
    const isSuggestion = props.searchResultItem.entity?.isSuggestion;

    function getToolTip(): string {
        if (!isApproved && isSuggestion)
            return getText("LatestChangesNotApprovedLabel");
        else if (!isApproved && !isSuggestion)
            return getText("NewlyAddedEntryNotApprovedLabel");
        else
            return null;
    }

    return (
        <div className={styles.titleContainer} title={title}>
            <ElementWithIcon includeIcon={cacheStore.validateMylePharmacy(ContactDirectoryHelper.isMylePharmacy(props.searchResultItem.entity))}>
                <div className={`${props.isSubItem ? "" : "DarkBlue"} ${styles.subtitle} ${styles.titleLabel}`}>{title}</div>
            </ElementWithIcon>
            <div>
                {!isApproved && (
                    <Icon
                        title={getToolTip()}
                        type="question-circle"
                        color="orange"
                    />
                )}
            </div>
        </div>
    );
}
